import React from 'react';
import styles from '../assets/styles.scss';
import { AnimationProgress } from './AnimationProgress';
import { PlayBoldSmall } from '@wix/wix-ui-icons-common/classic-editor';
import type { AnimationThumbnailProps, AnimationProgressAPI } from '../types';

export const AnimationTumbnail: React.FC<AnimationThumbnailProps> =
  React.forwardRef(
    (
      {
        width,
        height,
        thumb: Thumb,
        selected,
        getDuration = () => 0,
        onClickPreview,
        onHoverPreview,
        onPreviewStop,
        hoverPreviewDelay = 200,
        showPlayIconOnSelected = true,
      },
      ref,
    ) => {
      const [progress, setProgress] =
        React.useState<AnimationProgressAPI | null>(null);
      const previewDelayTimer = React.useRef<NodeJS.Timeout | null>(null);
      const onProgressClick = () => {
        if (!progress?.isPlaying) {
          progress?.play(getDuration());
          onClickPreview?.();
        } else {
          progress?.stop();
          onPreviewStop?.();
        }
      };

      const onMouseEnter = () => {
        if (!selected && onHoverPreview) {
          clearTimeout(previewDelayTimer.current!);
          previewDelayTimer.current = setTimeout(
            onHoverPreview,
            hoverPreviewDelay,
          );
        }
      };

      const onMouseLeave = () => {
        if (!selected && onPreviewStop) {
          clearTimeout(previewDelayTimer.current!);
          onPreviewStop();
        }
      };

      return (
        <div
          style={{ width, height }}
          data-selected={selected ? 1 : undefined}
          data-keep={progress?.isPlaying ? 1 : undefined}
          className={styles.animationThumb}
          ref={ref}
        >
          <div
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            className={
              showPlayIconOnSelected ? styles.animationThumbIdle : undefined
            }
            onClick={
              selected && showPlayIconOnSelected
                ? onProgressClick
                : onPreviewStop
            }
          >
            <Thumb />
          </div>
          {selected && showPlayIconOnSelected ? (
            <div className={styles.animationThumbHover}>
              <AnimationProgress
                ref={setProgress}
                width={width / 2}
                strokeWidth={2}
                angle={0}
                direction="cw"
                track={{
                  strokeWidth: 2,
                  opacity: 0.35,
                }}
              />
              <PlayBoldSmall width={24} height={24} />
            </div>
          ) : null}
        </div>
      );
    },
  );
